import request from '../../utils/request';

const BASE_URL = process.env.REACT_APP_EXPRESS_URL;
const URL = BASE_URL + '/seasons';

class Api {
  static async getAll() {
    const response = await request('get', URL);
    return response.data;
  }

  static async update(changedEntries) {
    await request('post', URL, { changedEntries });
    return this.getAll();
  }
}

export default Api;
